import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Checkbox,
  Stack,
} from '@chakra-ui/react';

interface SelectFiltersProps {
  selects: { title: string; options: string[] }[];
  handleChange?: (option: string, title: string, checked: boolean) => void;
  selected?: string[];
}

export const SelectFilters: React.FC<SelectFiltersProps> = ({
  selects,
  handleChange,
  selected,
}) => {
  return (
    <Accordion w="96%" defaultIndex={[0, 1, 2]} allowMultiple={true}>
      {selects?.map(filter => (
        <AccordionItem borderColor="transparent" key={filter.title}>
          <Box>
            <AccordionButton
              justifyContent="space-between"
              fontWeight={500}
              textColor="black"
            >
              {filter.title}

              <AccordionIcon color="black" />
            </AccordionButton>
            <AccordionPanel>
              <Stack aria-label={`Mudar exibição para ${filter.title}`}>
                {filter.options.map(option => (
                  <Checkbox
                    isChecked={selected?.includes(option)}
                    key={option}
                    fontWeight={500}
                    onChange={e =>
                      handleChange?.(option, filter.title, e.target.checked)
                    }
                    color="text.100"
                    fontSize="14px"
                  >
                    {option}
                  </Checkbox>
                ))}
              </Stack>
            </AccordionPanel>
          </Box>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
